//helpers
import { dynamicParameter } from '@/mixins/service/mixin-service';
import cloneDeep from 'lodash/cloneDeep'
import dateFormatter from '@/services/formatter_services/date-formatter';
import get from 'lodash/get';
import restUtils from '@/utils/rest-utils.js';
import writeXlsxFile from 'write-excel-file';
import axios from 'axios';

export default function (notVisibleHeaders = [], bulkIds = [], excludeIds = []) {
    const getNotVisibleHeaders = dynamicParameter(notVisibleHeaders);
    const getBulkIds = dynamicParameter(bulkIds);
    const getExcludeIds = dynamicParameter(excludeIds);

    return {
        props: {
            excelObjectDataPath: { type: String, default: 'data.' },
        },
        data() {
            return {
                filename: undefined,
                excelExportLoading: false,
            }
        },
        methods: {
            deepGet(obj, path) {
                return get(obj, path) ?? get(obj?.data, path);
            },
            fetchExcelData() {
                this.excelExportLoading = true;
                let schema = [];
                let responseDataPath = this.excelObjectDataPath ?? '';
                const clonedHeaders = cloneDeep(this.internalHeaders ?? this.headers);
                const sortedHeaders = clonedHeaders.sort((header1, header2) => {
                    const positionFilter1 = this.orderedHeaders.findIndex(
                        (_value) => _value === header1.value
                    );
                    const positionFilter2 = this.orderedHeaders.findIndex(
                        (_value) => _value === header2.value
                    );
                    return positionFilter1 - positionFilter2;
                });

                let filteredHeaders = sortedHeaders.filter(el => !getNotVisibleHeaders(this).includes(el.value));
                filteredHeaders.forEach((el) => {
                    let valPath = responseDataPath + el.value;
                    let cellType = el.type ?? String;

                    schema.push({
                        column: el.text,
                        value: item => {
                            const value = this.deepGet(item, valPath);
                            if (el.presentWithInExcelExport && value !== undefined) {
                                return el.presentWithInExcelExport(value, item?.data ?? item);
                            }

                            if (!el.presentWithRequiresParamItem && (value === undefined || value === null)) {
                                return '';
                            }

                            if (!el.presentWith) {
                                return value ? cellType(value) : '';
                            }

                            return cellType(el.presentWith(value, item?.data ?? item));
                        },
                        type: cellType,
                        format: el.format ?? undefined,
                        getCellStyle: (obj) => ({
                            fontWeight: el.fontWeight ? el.fontWeight(obj) : 'normal'
                        }),
                    });
                });

                this.filename = this.name + '_' + dateFormatter.getLocalDateTimeStringNow();

                let sortOptions = {};
                for (let i = 0; i < this.sortBy.length; i++) {
                    sortOptions[this.sortBy[i]] = this.sortDesc[i];
                }
                const processedFilters = cloneDeep(this.filters) ?? [];
                for (const [key, value] of Object.entries(processedFilters)) {
                    if (Array.isArray(value)) {
                        processedFilters[key] = value.map(v => encodeURIComponent(v)).join(',');
                    }
                }
                const mandatoryFilters = cloneDeep(this.mandatoryFilters);
                for (const [key, value] of Object.entries(mandatoryFilters ?? {})) {
                    if (Array.isArray(value)) {
                        mandatoryFilters[key] = value.map(v => encodeURIComponent(v)).join(',');
                    }
                }
                if (this.search)
                    processedFilters['search'] = this.search

                let bulkIds = getBulkIds(this);
                let excludeIdsSelectionMode = getExcludeIds(this);

                if (bulkIds !== undefined && excludeIdsSelectionMode !== undefined) {
                    if (excludeIdsSelectionMode && bulkIds.length > 0) {
                        processedFilters.excludeIds = bulkIds.join(',')
                    } else if (!excludeIdsSelectionMode && bulkIds.length > 0) {
                        processedFilters.ids = bulkIds.join(',')
                    }
                }
                axios
                    .get('/rest/v4/' + this.path, {
                        params: {
                            ...processedFilters,
                            ...mandatoryFilters,
                            sort: restUtils.convertSortOptionsToQueryParam(sortOptions),
                            requestType: 'EXPORT'
                        },
                    })
                    .then((response) => {
                        let responseDataItems = response.data.data;

                        if (this.path === 'projectaccounting') {
                            responseDataItems = response.data.billingItems;
                        }
                        if (!responseDataItems[0].data) {
                            responseDataItems.forEach((e) => {
                                e.data = e;
                            });
                        }
                        writeXlsxFile(responseDataItems, {
                            schema,
                            fileName: this.filename + '.xlsx',
                        });
                    })
                    .catch((error) => {
                        window.console.error(error);
                    })
                    .finally(() => {
                        this.excelExportLoading = false
                    });
            },
        },
    }
}